import TenderTreeList from "./components/tenderTree-list";
import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import React, {useEffect} from "react";
import AddActionButton from "../../components/action-buttons/addAction-button/AddActionButton";
import {useAuth} from "../../context/authContext";
import {useTenderProcurementsController} from "../../controllers/tenderProcurements-controller";
import TenderProcurementsModal from "./components/add-modal/TenderProcurementsModal";
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import "./style.less";

const TenderProcurementsPage = () => {
  const {canManageContent} = useAuth()
  const tenderProcurementsController = useTenderProcurementsController()
  const {
    toggleModal,
    isModalOpen,
    fetchTenderProcurementsList,
    lastUpdate,
  } = tenderProcurementsController

  useEffect(() => {
    fetchTenderProcurementsList([])
  }, [lastUpdate])

  const headerActions = <>
    {canManageContent && <AddActionButton onClick={toggleModal}/>}
  </>

  return <>
    <div className="page_title">
      <PageHeader
        title={
          <div className="page-header_title">
            <div className="page_name">Інформація по тендерних закупівлях</div>
          </div>
        }
        extra={headerActions}
        onBack={navigateBackHandler}
      />
    </div>

    <div className="page_content tender-procurements-page">
      <TenderTreeList tenderProcurementsController={tenderProcurementsController}/>
      <ScrollToTopButton elementSelector={".page_content"}/>
    </div>
    {isModalOpen && <TenderProcurementsModal tenderProcurementsController={tenderProcurementsController}/>}
  </>
}

export default TenderProcurementsPage
